import React, {Component} from 'react';
import {connect} from 'react-redux';

import {t} from 'l10n';

import { formatDateHM, formatDate } from 'utils/formatDate';

import Loading from 'components/Loading';

import { deleteMemberMessageToDialog } from 'reducers/memberMessageDialog';

import '../../sass/member/MemberMessageItem.scss';

class MessageDialogItem extends Component {

    constructor(props) {
        super(props);

        this.state = {
            deleted: false,
            pendingDelete: false,
            read: !props.messageError && props.item.old === 1,
        };
    }

    componentDidUpdate() {
        const { read } = this.state;
        const { readNewMessage } = this.props;

        readNewMessage && !read ? this.setState({read: true}) : false;
    }

    deleteMsg() {
        const { item, dispatch } = this.props;

        const reducerParams = {
            id: item.id,
            action: 'delete-message'
        };

        this.setState({pendingDelete: true})

        let action = deleteMemberMessageToDialog(reducerParams);

        dispatch(action);

        action.promise
            .then(() => {
                this.setState({
                    deleted: true
                });
            })
            .catch((e) => this.setState({pendingDelete: false}))
    }

    deleteConfirmMsg() {
        window.confirm(t('Do you really want to delete this message?')) && this.deleteMsg();
    }

    render() {
        if(this.props.messageError) {
            return (
                <div className="one-message">
                    <div className="name-one-message">
                        <p className="error-message" dangerouslySetInnerHTML={{__html: this.props.messageError }} />
                    </div>
                </div>
            )
        }

        const {
            read,
            deleted,
            pendingDelete,
        } = this.state;

        if(deleted) return false;
        if(pendingDelete) return <Loading />;

        const {
            old,
            date,
            author,
            message,
            recipient
        } = this.props.item;

        return (
            <div className={`one-message ${!old && !read ? `unread-message` : ''}`}>
                <div className="name-one-message">
                    <p>{author.nick}</p>
                    <span className="date">{formatDate(date)}</span>
                    <div className="delete" onClick={() => this.deleteConfirmMsg()  }/>
                </div>
                <div className="text" dangerouslySetInnerHTML={{__html: message}}></div>
            </div>
        )
    }
}

export default connect(
    (state) => ({
    }),
    null
)(MessageDialogItem);


// WEBPACK FOOTER //
// ./src/components/message/MessageDialogItem.js